import { useState, useEffect } from "react";
import styles from "../../css/CookieConsent.module.css";
import { getCookie, setCookie } from "../../helpers/functions/cookies";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const CONSENT_COOKIE = "meratractor_cookie_consent";

  useEffect(() => {
    const consent = getCookie(CONSENT_COOKIE);
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    // Store consent in cookie for 365 days (1 year)
    setCookie(CONSENT_COOKIE, "accepted", 365);
    setShowConsent(false);

    // Initialize or restart Clarity
    if (window.clarity) {
      window.clarity("restart");
    }
    console.log("Cookies accepted - Analytics enabled");
  };

  const handleDecline = () => {
    // Store decline in cookie for 365 days
    setCookie(CONSENT_COOKIE, "declined", 365);
    setShowConsent(false);

    // Stop Clarity tracking
    if (window.clarity) {
      window.clarity("restart");
    }
    console.log("Cookies declined - Analytics disabled");
  };

  if (!showConsent) return null;

  return (
    <div className={styles["cookie-consent-overlay"]}>
      <div className={styles["cookie-consent-container"]}>
        <div className={styles["cookie-consent-content"]}>
          <h5 className={styles["cookie-consent-title"]}>
            <i className="bi bi-shield-check me-2"></i>
            Cookie Consent
          </h5>

          <p className={styles["cookie-consent-text"]}>
            We use cookies and analytics tools like Microsoft Clarity to improve
            your experience, analyze site traffic, and understand user behavior.
            By clicking {`"Accept"`}, you consent to our use of cookies. Your
            preference will be stored permanently.
          </p>
          {/* <div className={styles["cookie-consent-actions"]}> */}
          <div
            className={
              " d-flex gap-2 align-items-center justify-content-lg-start justify-content-center"
            }
          >
            <button
              className="btn btn-outline-light btn-sm me-2"
              onClick={handleDecline}
            >
              Decline
            </button>
            <button className="btn btn-warning btn-sm" onClick={handleAccept}>
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
